<template>
  <div class="paindexouter">
    <!--    登录注册-->
    <div class="page-index">
      <!--      <img class="videoone" src="../assets/1920915.png" alt="">-->
      <div class="wmiddle" style="top: 80px;">
        <div class="flex-cc">
          <img class="mlogo1" src="../assets/logo.png" alt="">
          <div class="mlogo2">
            <div class="mlp1">网络空间内生安全知识平台</div>
            <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
          </div>
        </div>
        <div class="login1">
          <div class="flex-hc">
            <div @click="changelonum(0)" :class="['logind1',locolnum==0?'logindhot':'']">登录</div>
            <div @click="changelonum(1)" :class="['logind1',locolnum==1?'logindhot':'']">注册</div>
          </div>
          <el-form :model="loginform" :rules="rules" ref="loginform" label-width="100px"
                   class="demo-ruleForm loginform">
            <el-form-item label="用户名" prop="nickname">
              <el-input class="colorinput" placeholder="请输入" v-model="loginform.nickname"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="name" v-if="locolnum == 1">
              <el-input placeholder="请输入" v-model="loginform.name"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input placeholder="请输入" v-model="loginform.password" show-password></el-input>
              <!--              <el-input placeholder="请输入" v-model="loginform.password"></el-input>-->
            </el-form-item>
            <el-form-item class="yaninput" label="图形验证码" prop="captchaCode" v-if="locolnum == 0">
              <el-input placeholder="请输入" v-model="loginform.captchaCode" style="width: 60%;"></el-input>
              <div class="captcha-container" @click="refreshCaptcha" style="display: inline-block; margin-left: 10px; cursor: pointer;">
                <img v-if="captchaImage" :src="captchaImage" alt="验证码" style="height: 40px; vertical-align: middle;">
                <span v-else style="color: #999;">获取</span>
              </div>
            </el-form-item>
            <el-form-item label="重复密码" prop="pwd" v-if="locolnum == 1">
              <el-input placeholder="请输入" v-model="loginform.pwd" show-password></el-input>
              <!--              <el-input placeholder="请输入" v-model="loginform.pwd"></el-input>-->
            </el-form-item>
            <el-form-item label="地区" prop="areaId" v-if="locolnum == 1">
              <el-cascader
                  :options="treearea"
                  :props="props"
                  v-model="loginform.areaId"
                  @change="handleChange"
                  clearable></el-cascader>
            </el-form-item>
            <el-form-item label="工作单位" prop="unit" v-if="locolnum == 1">
              <el-select v-model="loginform.unit" placeholder="请选择">
                <el-option
                    v-for="item in unitlist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" v-if="locolnum == 1">
              <el-input placeholder="请输入" v-model="loginform.email"></el-input>
            </el-form-item>
            <el-form-item class="yaninput" label="图形验证码" prop="emailCaptchaCode" v-if="locolnum == 1">
              <el-input placeholder="请输入" v-model="loginform.emailCaptchaCode" style="width: 60%;"></el-input>
              <div class="captcha-container" @click="refreshEmailCaptcha" style="display: inline-block; margin-left: 10px; cursor: pointer;">
                <img v-if="emailCaptchaImage" :src="emailCaptchaImage" alt="验证码" style="height: 40px; vertical-align: middle;">
                <span v-else style="color: #999;">获取</span>
              </div>
            </el-form-item>
            <el-form-item class="yaninput" label="邮箱验证码" prop="code" v-if="locolnum == 1">
              <el-input placeholder="请输入" v-model="loginform.code" style="width: 60%;"></el-input>
              <div @click="!isSend && getcode()" :class="['cgetm', {'disabled': isSend}]">{{ msg }}</div>
            </el-form-item>
            <el-form-item>
              <div @click="submitForm('loginform')" class="cloginb1">{{
                  locolnum == 0 ? '立即登录' : '注册并登录'
                }}
              </div>

              <div class="fogetm mt10" v-if="locolnum == 0">
                <span>忘记密码？</span><span @click="recover">找回密码</span>
              </div>
              <!--              <el-button type="primary" @click="submitForm('loginform')">立即创建</el-button>-->
              <!--              <el-button @click="resetForm('loginform')">重置</el-button>-->
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
    <div class="bottomd flex-cc">
      <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
      <span class="shus"></span>
      <img src="../assets/guohui.png" class="jinghui" alt="">
      <span>苏CP备14016373号-4</span>
    </div>

    <el-dialog
        title="找回密码"
        class="tanpass1"
        append-to-body
        :show-close="false"
        :visible.sync="recoverlook"
        width="40%">
      <el-form :model="recoverform" :rules="rules" ref="recoverform" label-width="100px"
               class="demo-ruleForm loginform">
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入" v-model="recoverform.email"></el-input>
        </el-form-item>
        <el-form-item class="yaninput" label="图形验证码" prop="emailCaptchaCode">
          <el-input placeholder="请输入" v-model="recoverform.emailCaptchaCode" style="width: 60%;"></el-input>
          <div class="captcha-container" @click="refreshRecoverCaptcha" style="display: inline-block; margin-left: 10px; cursor: pointer;">
            <img v-if="recoverCaptchaImage" :src="recoverCaptchaImage" alt="验证码" style="height: 40px; vertical-align: middle;">
            <span v-else style="color: #999;">获取</span>
          </div>
        </el-form-item>
        <el-form-item class="yaninput" label="邮箱验证码" prop="code">
          <el-input placeholder="请输入" autocomplete="new-password" v-model="recoverform.code" style="width: 60%;"></el-input>
          <div @click="!isSendt && getcodet()" :class="['cgetm', {'disabled': isSendt}]">{{ msgt }}</div>
        </el-form-item>
        <el-form-item label="设置新密码" prop="password">
          <el-input placeholder="请输入" autocomplete="new-password" v-model="recoverform.password"
                    show-password></el-input>
          <!--          <el-input placeholder="请输入" v-model="recoverform.password"></el-input>-->
        </el-form-item>
        <el-form-item label="重复新密码" prop="pwd">
          <el-input placeholder="请输入" v-model="recoverform.pwd" show-password></el-input>
          <!--          <el-input placeholder="请输入" v-model="recoverform.pwd"></el-input>-->
        </el-form-item>
        <el-form-item>
          <div class="w100 flex-cc">
            <div @click="closerecover" class="quxiaohui mr20">取消</div>
            <div @click="submitFormcover('recoverform')" class="querenlan">确定</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
import $ from 'jquery'

export default {
  data() {
    // 邮箱正则表达式
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 密码强度验证函数
    const validatePassword = (rule, value, callback) => {
      if (this.locolnum == 0 && !this.recoverlook) {
        if (!value) {
          return callback(new Error('请输入密码'))
        }
        callback()
        return false
      }
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      // 定义字符类型
      const hasLower = /[a-z]/.test(value) // 小写字母
      const hasUpper = /[A-Z]/.test(value) // 大写字母
      const hasNumber = /\d/.test(value)   // 数字
      const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value) // 特殊字符

      // 统计字符类型数量
      const typeCount = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length

      if (typeCount < 3) {
        return callback(new Error('密码需包含至少三种字符类型（数字、大小写字母、特殊字符）'))
      }

      // 额外长度要求
      if (value.length < 8) {
        return callback(new Error('密码长度至少8位'))
      }
      if (value.length > 20) {
        return callback(new Error('密码长度不能超过20位'))
      }

      callback()
    }
    // 密码强度验证函数
    const valtwo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      if (this.locolnum == 1) {//忘记密码
        if (value != this.loginform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      if (this.recoverlook) {//找回密码
        if (value != this.recoverform.password) {
          return callback(new Error('两次密码输入不一致'))
        }
      }
      callback()
    }
    // 密码强度验证函数
    const valthr = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }

      if (value != this.editform.password) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    return {
      url: '',
      treearea: [],
      unitlist: [],
      props: {
        label: 'name',
        children: 'children',
        value: 'id',
        emitPath: false
      },
      locolnum: 0,//0立即登录
      pickerPlacement: 'bottom-start',
      sform: {
        input: '',
        time: '',
        user: '',
        categoryId: '',
      },
      // 消息
      xform: {
        input: '',
        time: '',
      },
      msg: '获取',
      seconds: 60,
      clock: null,
      isSend: false,
      msgt: '获取',
      secondst: 60,
      clockt: null,
      isSendt: false,
      captchaImage: '', // 登录图形验证码图片
      emailCaptchaImage: '', // 注册邮箱验证码图形验证码图片
      recoverCaptchaImage: '', // 找回密码图形验证码图片
      mynum: 0,//0邀请的1回复我的
      lunnum: 0,//0发布的1回复的
      xtopnum: 0,//顶部切换0个人信息1修改密码2我的论坛3消息，
      titlew: ' 中外专家为构建网络安全免疫系统建言献策 ',
      recoverlook: false,//找回密码
      imageUrl: '',//头像
      userinfo: JSON.parse(localStorage.getItem('muiuserinfo'))?.userInfo || null,
      datayaolist: [],
      // 登录
      loginform: {
        // nickname: 'a1',
        // password: '123456qaz+',
        nickname: '',
        password: '',
        name: '',
        email: '',
        pwd: '',
        code: '',
        areaId: '',
        unit: '',
        captchaId: '',
        captchaCode: '',
        emailCaptchaId: '',
        emailCaptchaCode: '',
      },
      // 找回密码
      recoverform: {
        code: '',
        email: '',
        password: '',
        pwd: '',
        emailCaptchaId: '',
        emailCaptchaCode: '',
      },
      // 个人信息
      infoform: {
        name: '',
        role: '',
        dept: '',
      },
      // 修改密码
      editform: {
        passwordy: '',
        password: '',
        passthr: '',
      },
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pageObjh: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      datahuimylist: [],//回复我的
      datalist: [],
      // 我发布的
      pageObjlone: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      // 我回复的
      datalisttwo: [],
      pageObjltwo: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      rules: {
        nickname: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        passwordy: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        code: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        // areaId: [
        //   {required: true, message: '请选择', trigger: ['blur', 'change']}
        // ],
        unit: [
          {required: true, message: '请选择', trigger: ['blur', 'change']}
        ],
        pwd: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valtwo, trigger: ['blur', 'change']}
        ],
        passthr: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: valthr, trigger: ['blur', 'change']}
        ],
        password: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
          {validator: validatePassword, trigger: ['blur', 'change']}
        ],
        captchaCode: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        emailCaptchaCode: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      rulesrecover: {
        name: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        emailCaptchaCode: [
          {required: true, message: '请输入', trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '请输入邮箱地址', trigger: 'blur'},
          {
            pattern: emailPattern,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          }
        ],
      },
      qiunum: '',
      ipAddress: '',
      topprops: {
        label: 'name',
        children: 'children',
        value: 'id',
        // emitPath:false
      },
      neilist: [],
      noreadinfo: '',//未读信息
    }
  },
  props: {
    colorindex: [String, Object, Array, Number],
    // infonum: [String, Object, Array, Number],
  },
  watch: {
    colorindex: function (val) {
    },
    $route(to, from) {
      // if (this.$route.query.value) {
      //     let value = String(this.$route.query.value)
      //     this.to(value);
      // }
    }
  },

  beforeDestroy() {
    // 清理定时器，防止内存泄漏
    if (this.clock) {
      clearInterval(this.clock);
    }
    if (this.clockt) {
      clearInterval(this.clockt);
    }
  },
  created() {
    this.getData()
    // if (this.$route.query.value) {
    //     this.to(this.$route.query.value)
    // }
  },
  mounted() {
    // 打包放开
    // this.loginform = {
    //   nickname: '',
    //   name: '',
    //   email: '',
    //   password: '',
    //   pwd: '',
    // }
    // 以下注释内容，测试完可以删除
    // 获取ip地址所属区域
    // this.getIpAddress()
    // 本地存储如果有,说明是点击上面的进来的,并且要根据点击的去刷新指定的框
    // if(localStorage.getItem('infonum')){
    //   let num = Number(localStorage.getItem('infonum'))
    //   this.xtopnum = num;
    //   if(num == 2){//我发布的
    //     this.getlunlist();
    //   }else if(num == 3){
    //     this.getmsglist()
    //   }
    // }
    // 回显个人信息
    // if(localStorage.getItem('muiuserinfo')){
    //   this.userinfo = JSON.parse(localStorage.getItem('muiuserinfo'));
    //   this.infoform = {
    //     name: this.userinfo.name,
    //     role: this.userinfo.role,
    //     dept: this.userinfo.dept,
    //   }
    //   if(this.userinfo.photo){
    //     this.imageUrl = this.userinfo.photo;
    //   }
    // }
    // 个人信息未读和已读
    // this.getnoread();
    // 点击日期选择器之外关闭选项
    // this.getneilist();//获取顶部分类
    // $('.qiuout').children('.qiuone').hover(function () {
    //   $(this).addClass('qiuhot').siblings('.qiuone').removeClass('qiuhot');
    // });
    this.gettree();
    this.getunit();
    // 登录页面加载时获取验证码
    if (this.locolnum == 0) {
      this.refreshCaptcha();
    }
  },
  // 22
  methods: {
    // 获取登录图形验证码
    refreshCaptcha() {
      this.$http({
        url: "user/captcha",
        method: "POST",
        data: {}
      }).then(res => {
        if (res.code == 10200 && res.data) {
          this.captchaImage = res.data.captchaImage;
          this.loginform.captchaId = res.data.captchaId;
          this.loginform.captchaCode = ''; // 清空验证码输入
        }
      }).catch(err => {
        console.error('获取验证码失败', err);
      });
    },
    // 获取注册邮箱验证码图形验证码
    refreshEmailCaptcha() {
      this.$http({
        url: "user/captcha",
        method: "POST",
        data: {}
      }).then(res => {
        if (res.code == 10200 && res.data) {
          this.emailCaptchaImage = res.data.captchaImage;
          this.loginform.emailCaptchaId = res.data.captchaId;
          this.loginform.emailCaptchaCode = ''; // 清空验证码输入
        }
      }).catch(err => {
        console.error('获取验证码失败', err);
      });
    },
    // 获取找回密码图形验证码
    refreshRecoverCaptcha() {
      this.$http({
        url: "user/captcha",
        method: "POST",
        data: {}
      }).then(res => {
        if (res.code == 10200 && res.data) {
          this.recoverCaptchaImage = res.data.captchaImage;
          this.recoverform.emailCaptchaId = res.data.captchaId;
          this.recoverform.emailCaptchaCode = ''; // 清空验证码输入
        }
      }).catch(err => {
        console.error('获取验证码失败', err);
      });
    },
    gettree() {
      let data = {}
      this.$http({
        url: "area/tree",
        method: "POST",
        data: data
      }).then(res => {
        // let treearea = JSON.parse(JSON.stringify(res.data));
        this.treearea = res.data;
        // if(treearea){
        //   treearea.forEach((item,index)=>{
        //     if(item.children){
        //       item.disabled = true;
        //     }
        //   })
        //   this.treearea = treearea;
        // }
        console.log('treearea', this.treearea)
      });
    },
    getunit() {
      let data = {}
      this.$http({
        url: "unit/list",
        method: "POST",
        data: data
      }).then(res => {
        let data=[];
        if(res.data){
          res.data.forEach((item) => {
            data.push({name:item,id:item});
          })
          this.unitlist = data;
        }
      });
    },
    handleChange(e) {
      console.log(e)
    },
    // 未读数量
    getnoread() {
      let data = {}
      this.$http({
        url: "msg/count",
        method: "POST",
        data: data
      }).then(res => {
        this.noreadinfo = res.data;
      });
    },
    resetpage(val) {
      // this.mynum = 0;
      if (val) {//有值是顶部切换
        this.lunnum = 0;
        this.mynum = 0;
      }
      // this.datalist = [];
      // this.datalisttwo = [];
      this.pageObjltwo = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjlone = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.pageObjh = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    },
    getneilist() {
      let data = {
        auth:1
      }
      this.$http({
        url: 'category/tree',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        let neilist = JSON.parse(JSON.stringify(res.data));
        if (neilist) {
          neilist.forEach((item, index) => {
            if (!item.children) {
              item.disabled = true;
            }
          })
          this.neilist = neilist;
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    handleModify() {
      this.imageUrl = '';
      this.$nextTick(() => {
        this.$el.querySelector('.el-upload__input').click();
      });
    },
    // 顶部切换
    changextop(val) {
      this.$nextTick(() => {
        this.$refs.editform.clearValidate();
      })
      localStorage.setItem('infonum', val);//个人信息的切换靠这个显示
      this.xtopnum = val;
      this.resetpage(1)
      if (val == 2) {//我的论坛
        this.getlunlist();
      } else if (val == 3) {
        this.getmsglist()
      }
    },
    // 我发布的列表
    getlunlist() {
      let data = {};
      data.pageNumber = this.pageObjlone.currentPage;
      data.pageSize = this.pageObjlone.pageSize;
      data.type = 1;
      this.$http({
        url: "post/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjlone.total = res.data.total;
        this.datalist = res.data.records;
      });
    },
    // 消息-邀请我的
    getmsglist() {
      let data = JSON.parse(JSON.stringify(this.xform));
      data.pageNumber = this.pageObj.currentPage;
      data.pageSize = this.pageObj.pageSize;
      data.time = data.time && data.time.length == 2 ? (this.$timeDay(data.time[0], 1) + '~' + this.$timeDay(data.time[1], 1)) : '';
      this.$http({
        url: "msg/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObj.total = res.data.total;
        this.datayaolist = res.data.records;
      });
    },
    // 消息-回复我的
    gethuimy() {
      let data = {};
      data.pageNumber = this.pageObjh.currentPage;
      data.pageSize = this.pageObjh.pageSize;
      data.type = 1;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjh.total = res.data.total;
        this.datahuimylist = res.data.records;
      });
    },
    // 我回复的
    getmyhuilist() {
      let data = {};
      data.pageNumber = this.pageObjltwo.currentPage;
      data.pageSize = this.pageObjltwo.pageSize;
      data.type = 0;
      this.$http({
        url: "comment/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjltwo.total = res.data.total;
        this.datalisttwo = res.data.records;
      });
    },
    pageChange(page) {
      this.pageObj.currentPage = page;
      this.getmsglist();
    },
    pageChangeh(page) {
      this.pageObjh.currentPage = page;
      this.gethuimy();
    },
    pageChangelone(page) {
      this.pageObjlone.currentPage = page;
      this.getlunlist();
    },
    pageChangeltwo(page) {
      this.pageObjltwo.currentPage = page;
      this.getmyhuilist();
    },
    changenum(num) {
      this.mynum = num;
      this.resetpage();
      if (this.mynum == 0) {
        this.getmsglist();
      } else {
        this.gethuimy();
      }
    },
    changelunnum(num) {
      this.lunnum = num;
      this.resetpage();
      if (this.lunnum == 0) {
        this.getlunlist();
      } else {
        this.getmyhuilist();
      }
    },
    closerecover() {
      this.loginform = Object.assign(this.loginform, this.$options.data().loginform)
      this.recoverlook = false;
    },
    recover() {
      this.recoverform = Object.assign(this.recoverform, this.$options.data().recoverform)
      this.recoverlook = true;
      this.$nextTick(() => {
        this.$refs.recoverform.clearValidate();
      })
      // 打开找回密码对话框时获取图形验证码
      this.refreshRecoverCaptcha();
    },
    getcode() {
      if (this.isSend) {
        return
      }
      // 验证图形验证码是否已输入
      if (!this.loginform.emailCaptchaCode) {
        this.$message.error('请先输入图形验证码');
        return;
      }
      this.isSend = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      let data = {
        email: this.loginform.email,
        captchaId: this.loginform.emailCaptchaId,
        captchaCode: this.loginform.emailCaptchaCode
      }
      this.$http({
        url: "emailcode",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        console.log('发送了吗注册', res.data)
        // 发送成功后刷新图形验证码
        this.refreshEmailCaptcha();
        // 清除之前的定时器（如果存在）
        if (this.clock) {
          clearInterval(this.clock);
        }
        this.clock = setInterval(() => {
          this.seconds--;
          this.msg = `重新获取(${this.seconds}s)`;
          if (this.seconds === 0) {
            clearInterval(this.clock);
            this.clock = null;
            this.seconds = 60;
            this.isSend = false;
            this.msg = '获取';
          }
        }, 1000);
      }).catch(err => {
        // 清除定时器
        if (this.clock) {
          clearInterval(this.clock);
          this.clock = null;
        }
        this.seconds = 60;
        this.isSend = false;
        this.msg = '获取';
        // 发送失败时刷新图形验证码
        this.refreshEmailCaptcha();
      })
    },
    getcodet() {
      if (this.isSendt) {
        return
      }
      // 验证图形验证码是否已输入
      if (!this.recoverform.emailCaptchaCode) {
        this.$message.error('请先输入图形验证码');
        return;
      }
      this.isSendt = true;//定时开始之前一定要加上  不然会鬼畜 验证码
      // 鬼畜是因为点击的时候又重复出发定时器了  所有要加上this.isSend = true;
      let data = {
        email: this.recoverform.email,
        captchaId: this.recoverform.emailCaptchaId,
        captchaCode: this.recoverform.emailCaptchaCode
      }
      this.$http({
        url: "emailcode",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        console.log('发送了吗', res.data)
        // 发送成功后刷新图形验证码
        this.refreshRecoverCaptcha();
        // 清除之前的定时器（如果存在）
        if (this.clockt) {
          clearInterval(this.clockt);
        }
        this.clockt = setInterval(() => {
          this.secondst--;
          this.msgt = `重新获取(${this.secondst}s)`;
          if (this.secondst === 0) {
            clearInterval(this.clockt);
            this.clockt = null;
            this.secondst = 60;
            this.isSendt = false;
            this.msgt = '获取';
          }
        }, 1000);
      }).catch(err => {
        // 清除定时器
        if (this.clockt) {
          clearInterval(this.clockt);
          this.clockt = null;
        }
        this.secondst = 60;
        this.isSendt = false;
        this.msgt = '获取';
        // 发送失败时刷新图形验证码
        this.refreshRecoverCaptcha();
      })


    },
    // 注册
    submitForm(formName) {
      console.log(this.loginform)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let data = JSON.parse(JSON.stringify(this.loginform));
          this.loading = true;
          let url = "";
          if (this.locolnum == 0) {
            url = "user/login"
            data.pwd = this.$cryptoadd.encryptData(data.password);//加密
            // 登录时需要传递验证码参数
            data.captchaId = this.loginform.captchaId;
            data.captchaCode = this.loginform.captchaCode;
          } else {
            url = "user/reg"
          }
          this.$http({
            url: url,
            method: 'post',
            data: this.locolnum == 0 ? this.$form(data) : data
          }).then((res) => {
            this.loading = false;
            // 后端返回格式：{code: 10200, data: {token: "xxx", userInfo: {...}}}
            if (res.data && res.data.token && res.data.userInfo) {
              localStorage.setItem('muiuserinfo', JSON.stringify({
                token: res.data.token,
                userInfo: res.data.userInfo
              }))
              this.$router.replace({ path: '/' })
              this.$emit('changecolor', 0)
            } else {
              this.$message({
                message: '登录成功但用户信息异常，请重试',
                type: 'error'
              })
            }
          }).catch(err => {
            this.loading = false;
            // 登录失败时刷新验证码
            if (this.locolnum == 0) {
              this.refreshCaptcha();
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    subinfoform(formName) {
      let data = {
        photo: this.imageUrl,
        name: this.infoform.name
      }
      this.$http({
        url: "user/edit",
        method: "POST",
        data: data
      }).then(res => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        });
        this.getuserinfo()
      });
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    getuserinfo() {
      let data = {}
      this.$http({
        url: "user/info",
        method: "POST",
        data: data
      }).then(res => {
        this.userinfo = res.data;
        // 更新localStorage，保持token不变，只更新userInfo
        let userDataStr = localStorage.getItem('muiuserinfo');
        if(userDataStr) {
            try {
                let userData = JSON.parse(userDataStr);
                userData.userInfo = res.data;
                localStorage.setItem('muiuserinfo', JSON.stringify(userData));
            } catch(e) {
                // 如果解析失败，直接存储新格式
                localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
            }
        } else {
            localStorage.setItem('muiuserinfo', JSON.stringify({userInfo: res.data}));
        }
      });
    },
    subeditform(formName) {
      console.log('formName', formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            // oldpwd:this.$cryptoadd.encryptData(this.editform.passwordy),
            // pwd:this.$cryptoadd.encryptData(this.editform.passthr),
            oldpwd: this.editform.passwordy,
            pwd: this.editform.passthr,
          }
          this.$http({
            url: "user/editpwd",
            method: "POST",
            data: this.$form(data)
          }).then(res => {
            this.$message({
              message: '密码修改成功！',
              type: 'success'
            });
            this.editform = Object.assign(this.editform, this.$options.data().editform)
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitFormcover(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let data = JSON.parse(JSON.stringify(this.recoverform));
          // this.loading = true;
          this.$http({
            url: 'user/findpwd',
            method: 'post',
            data: this.$form(data)
          }).then((res) => {
            this.$message({
              message: '密码找回成功，请重新登录！',
              type: 'success'
            });
            this.loginform = Object.assign(this.loginform, this.$options.data().loginform)
            this.recoverlook = false;
            this.loading = false;
          }).catch(err => {
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changelonum(num) {
      this.locolnum = num;
      this.loginform = Object.assign(this.loginform, this.$options.data().loginform)
      this.$nextTick(() => {
        this.$refs.loginform.clearValidate();
      })
      // 切换到登录页面时获取验证码
      if (num == 0) {
        this.refreshCaptcha();
      } else if (num == 1) {
        // 切换到注册页面时获取邮箱验证码的图形验证码
        this.refreshEmailCaptcha();
      }
    },
    getIpAddress() { //获取ip, 位置
      let year = new Date().getFullYear();
      fetch(`https://${year}.ip138.com/`).then(x => x.text()).then(h => {
        let domParser = new DOMParser();
        let doc = domParser.parseFromString(h, "text/html");
        let text = doc?.querySelector('p')?.innerText?.trim();
        console.log('text', text)//您的iP地址是：[xxx.xx.xxx.xxx ] 来自：中国上海xx xx
        try {
          let ip = text.substring(text.indexOf("[") + 1, text.indexOf("]")).trim();
          this.ipAddress.ip = ip;
          let other = text.substring(text.indexOf("来自：") + 3).trim();
          let arr = other.split(" ");
          this.ipAddress.location = arr[0];
          this.ipAddress.type = arr[1];
        } catch (e) {
          console.error(e)
        }
      })
    },

    subsear() {
      console.log(this.sform)

      if (!this.userinfo) {
        this.$message({
          message: '请先进行登录再进行操作！',
          type: 'warning',
          duration: 2000
        });
        return false;
      }

      let timein = [];
      if (this.sform.time.length == 2) {
        timein = [this.$timeDay(this.sform.time[0], 1), this.$timeDay(this.sform.time[1], 1),];
      }
      if (!this.sform.categoryId) {
        this.$message({
          message: '文件类型不能为空！',
          type: 'error'
        });
        return false;
      }
      this.$router.push({
        path: 'knowledge',
        query: {
          parentid: this.sform.categoryId[0],//父级id
          id: this.sform.categoryId[1],//分类id
          time: JSON.stringify(timein),
          input: this.sform.input,
          user: this.sform.user,
        }
      })
    },
    resetsear() {
      console.log(this.sform)
    },
    onSubmit() {

    },
    to(val) {
      // this.color = val
      // this.Show = false
      // this.show = true
      // if (val == 'companyIntro') {
      //     this.companyShow = true;
      //     this.leaderShow = false;
      //     this.CultureShow = false;
      //     this.title = '公司简介'
      // } else if (val == 'leaderMessage') {
      //     this.companyShow = false;
      //     this.leaderShow = true;
      //     this.CultureShow = false;
      //     this.title = '领导寄语'
      // } else if (val == 'corporateCulture') {
      //     this.companyShow = false;
      //     this.leaderShow = false;
      //     this.CultureShow = true;
      //     this.title = '企业文化'
      // } else {
      //     this.title = '荣誉资质'
      //     this.goHonor(val)
      // }
    },
    getData() {
      // this.$http({
      //   url: 'aboutUs/queryAboutUsInfo',
      //   method: 'post'
      // }).then((res) => {
      //   this.aboutall = res.data
      //   this.aboutUs=res.data.aboutUs
      //   this.banner = res.data.banner
      // })
    },
    goHonor(val) {
      this.title = '荣誉资质'
      this.color = val
      this.Show = true
      this.show = false
      this.$http({
        url: 'aboutUs/queryHonors?page=1&limit=10',
        method: "post"
      }).then((res) => {
        this.honorList = res.data
      })
    }
  },
}
</script>
<!--33-->
<style src="@/styles/roatestyle.css" scoped></style>
<style scoped lang="scss">
/deep/ {
  .el-cascader:not(.is-disabled):hover .el-input__inner {
    border-color: #060F1E !important;
  }
  .cgetm{
    top: 40% !important;
  }
}
@media screen and (max-width: 1440px)  {
  .login1{
    height: 73vh !important;
  }
  .bottomd{
    display: none !important;
  }
}
.paindexouter {

  background-image: url("../assets/img/bgc2.png");
  background-size: cover;
  background-position: bottom center; /* 关键：底部对齐 */
  background-repeat: no-repeat;
}

.wmiddle {
  width: 1200px;
  margin: auto;
  height: 100vh;
  box-sizing: border-box;
  padding-top: 80px;
}
</style>
<style lang="scss">
.colorinput .el-input__inner:-webkit-autofill,
.colorinput .el-input__inner:-webkit-autofill:hover,
.colorinput .el-input__inner:-webkit-autofill:focus,
.colorinput .el-input__inner:-webkit-autofill:active {
  -webkit-text-fill-color: #fff !important;
  transition: background-color 999999s ease-in-out, color 999999s ease-in-out !important;
  color: #fff !important;
}

.touwai {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;

  .xiut {
    cursor: pointer;
    width: 100%;
    height: 33px;
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    line-height: 33px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    color: white;
    font-size: 15px;
  }

  .el-upload {
    img {
      width: 88px;
      height: 88px;
      border-radius: 50%;
    }
  }
}

.toptl1 {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  //border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  line-height: 88px !important;
  text-align: center;
  background: #0E3E6C;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.infored {
  width: 12px;
  height: 12px;
  background: red;
  border-radius: 50%;
  margin-left: 11px;
}

.pert {
  width: 150px;
  height: 50px;
  background: #0E3E6C;
  border: 1px solid #0090FF;
  border-radius: 16px 16px 0 0;
  font-size: 22px;
  margin-right: 10px;
  color: #fff;
  cursor: pointer;
}

.xtophot {
  background: #0090FF;
}

.mlogo5 {
  width: 80px;
  height: 80px;
  margin-right: 30px;
}

.pertmid {
  width: 100%;
  height: 650px;
  background: rgba(14, 62, 108, 0.8);
  border-radius: 0 16px 16px 16px;

  .permidleft {
    width: 20%;
    height: 100%;
    overflow-y: auto;
    background: rgba(14, 62, 108, 0.9);
    border-radius: 0 16px 16px 16px;
    box-sizing: border-box;
    padding: 20px 0;

    .perhot {
      background: linear-gradient(90deg, #075393 0%, rgba(14, 62, 108, 0.9) 100%);
      position: relative;
      transition: 0.8s;

      &::before {
        content: "";
        width: 6px;
        height: 26px;
        background: #0090FF;
        position: absolute;
        top: 17px;
        left: 0;
      }
    }

    .perw1 {
      width: 100%;
      height: 60px;
      font-size: 18px;
      color: white;
      cursor: pointer;

      .redm {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: red;
        margin-left: 15px;
      }

      .redmtran {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-left: 15px;
      }
    }
  }

  .permidright {
    width: 80%;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px 20px 40px;
    background: rgba(6, 15, 30, 0.6);
  }

  .permidright2 {
    width: 80%;
    overflow-y: auto;
    height: 100%;
    box-sizing: border-box;
    background: rgba(6, 15, 30, 0.6);
  }

  .permid2 {
    height: 75%;
    overflow-y: auto;
  }

  .permid22 {
    height: 88%;
    overflow-y: auto;
  }

  .lunlist1 {
    box-sizing: border-box;
    padding: 20px 40px;
    border-bottom: 1px solid #0C3761;
  }

  .permid21 {
    height: 90%;
    overflow-y: auto;
    box-sizing: border-box;
    padding-top: 20px;
  }

  .huits1 {
    font-size: 18px;
    color: white;
  }

  .huits3 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .huits4 {
    width: 21px;
    height: 19px;
    margin-right: 5px;
  }

  .huits6 {
    width: 21px;
    height: 19px;
    margin-left: 5px;
  }

  .huits5 {
    font-size: 16px;
    color: white;
  }

  .huitsnew5 {
    max-width: 90%;
    min-width: max-content;
  }

  .huits2 {
    font-size: 18px;
    color: #A0B8E2;
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms3 {
    font-size: 18px;
  }

  .perms1 {
    color: white;
  }

  .perms2 {
    color: #A0B8E2;
    margin-left: 6px;
    margin-right: 6px;
  }

  .perms5 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
  }

  .perms9 {
    font-size: 20px !important;
    font-weight: bold;
    color: white;
    margin-bottom: 15px;
    //cursor: none !important;
  }

  .perms9:hover {
    background: none;
    color: white !important;
  }

  .permb1 {
    font-size: 15px;
    color: #B2B4CB;
  }

  .permb2 {
    //width: 15px;
    //height: 13px;
    margin-right: 3px;
  }

  .mlr15 {
    margin-left: 15px;
    margin-right: 15px;
  }

  .mlr10 {
    margin-left: 10px;
    margin-right: 10px;
  }

  .perms6 {
    font-size: 16px;
    color: #B2B4CB;
  }

  .perms7 {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 16px;
    background: rgba(14, 62, 108, 0.8);
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

.tanpass1 {
  .el-dialog {
    border-radius: 16px;
  }

  .el-dialog__body {
    padding: 0 0 20px 0;
    background: #0B3E73;
    border-radius: 0 0 15px 15px;
  }

  .el-dialog__header {
    padding: 20px 0 0 0;
    background: #0B3E73;
    border-radius: 15px 15px 0 0;
    text-align: center;

    .el-dialog__title {
      color: white !important;
      font-size: 18px;
      font-weight: bold;
    }
  }

}

.yaninput {
  position: relative;

  .cgetm {
    position: absolute;
    right: 10px;
    top: 18px;
    font-size: 16px;
    line-height: 16px;
    color: #0090FF;
    cursor: pointer;
    user-select: none;
    transition: color 0.3s;
    
    &.disabled {
      color: #999;
      cursor: not-allowed;
      pointer-events: none;
    }
    
    &:hover:not(.disabled) {
      color: #00B0FF;
    }
  }

  .el-input__inner {
    box-sizing: border-box;
    padding-right: 90px;
  }
}

.el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important; /* 背景色 */
  -webkit-text-fill-color: #fff !important; /* 文字颜色 */
  color: white !important;
}

/* 仅针对密码输入框 */
.el-input__inner[type="password"]:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #060F1E inset !important;
}

.fogetm {
  width: 100%;
  text-align: center;
  color: white;
  margin-top: 10px;
  font-size: 16px;

  span {
    cursor: pointer;
  }

  span:nth-child(2) {
    text-decoration: underline;
  }
}

.loginformnew {
  width: 45% !important;
  margin-left: 22% !important;
}

.loginformnew .el-input .el-input__inner {
  background: rgba(6, 15, 30, 0.5) !important;
  border: 1px solid #092948 !important;
}

.loginform {
  width: 60%;
  margin-left: 15%;
  box-sizing: border-box;
  padding-top: 30px;
.el-select{
  width: 100%;
}
  .el-cascader {
    width: 100%;
  }

  .cloginb1 {
    cursor: pointer;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #0090FF;
    border-radius: 16px;
    text-align: center;
    font-size: 18px;
    color: white;
  }

  ///deep/ {
  .el-form-item__label {
    height: 55px;
    line-height: 55px;
    color: #fff;
    font-size: 16px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: '';
    color: #F56C6C;
  }

  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0090FF !important;
  }

  .el-input__inner::placeholder {
    color: #909399;
  }

  .el-input .el-input__inner {
    background: #060F1E;
    border: 1px solid #060F1E;
    //border-color: #060F1E;
    height: 55px;
    line-height: 55px;
    color: white;
    border-radius: 16px;
    -webkit-text-fill-color: #fff !important;
  }

  //}
}

.login1 {
  margin: 0 auto;
  width: 860px;
  height: 700px;
  margin-top: 10px;
  box-sizing: border-box;
  padding: 20px 40px 0 40px;
  border-radius: 16px;
  border: 1px solid #1D5FB2;
  background: rgba(6, 15, 30, 0.5);
  box-shadow: 2px 6px 20px 0px rgba(14, 62, 108, 0.2);
  overflow-y: auto;
  &::-webkit-scrollbar {display: inline-block !important;}
  .logind1 {
    cursor: pointer;
    width: 100px;
    text-align: center;
    //background: pink;
    font-size: 24px;
    color: white;
    position: relative;
    //font-weight: bold;
  }

  .logindhot::after {
    content: "";
    width: 20px;
    height: 5px;
    background: #0090FF;
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: -57px;
    margin: auto;
  }
}

.qiuno {
  background-image: url(../assets/qiu.png);
  background-repeat: no-repeat;
  cursor: pointer;
}

.qiux {
  background-image: url(../assets/qiuxuan.png);
  background-repeat: no-repeat;
  cursor: pointer;
  color: #0863B1;
}

.cqimg {
  width: 2rem;
  height: 2rem;
}

.cq-t1 {
  font-size: 1.7rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.cq-t2 {
  font-size: 1rem;
  color: white;
}

.cq-t3 {
  font-size: 1rem;
}

.main-out {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
}


.qiuout {
  //display: none;//放开
  width: 100%;
  height: 500px;
  //background: pink;
  position: relative;

  .qiuone {
    cursor: pointer;
    width: 180px;
    height: 180px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 50%;
    background-image: url("../assets/qiu.png");
    transition: 0.5s;

    .qium1 {
      height: 40px;
    }

    .qium2 {
      font-size: 17px;
      color: white;
    }
  }

  //.qiucold{
  //  background-image: url("../assets/qiu.png");
  //}
  .qiuhot {
    width: 150px !important;
    height: 150px !important;
    background-image: url("../assets/da.png") !important;
    transition: 0.5s;
  }

  .q1 {
    position: absolute;
    top: 220px;
    left: 30px;
  }

  .q2 {
    position: absolute;
    top: 66px;
    left: 170px;
  }

  .q3 {
    position: absolute;
    top: 276px;
    left: 190px;
  }

  .q4 {
    position: absolute;
    top: 146px;
    left: 320px;
  }

  .q5 {
    position: absolute;
    top: 0px;
    left: 420px;
  }

  .q6 {
    position: absolute;
    top: 160px;
    left: 500px;
  }

  .q7 {
    position: absolute;
    top: 320px;
    left: 440px;
  }

  .q8 {
    position: absolute;
    top: 70px;
    left: 660px;
  }

  .q9 {
    position: absolute;
    top: 270px;
    left: 720px;
  }

  .q10 {
    position: absolute;
    top: 90px;
    left: 860px;
  }

  .q11 {
    position: absolute;
    top: 280px;
    left: 940px;
  }
}


.page-index {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
}

.videoone {
  width: 100%;
  height: 100%;
  //object-fit: cover; /* 保持视频比例并覆盖整个容器 */
}

.videotwo {
  width: 100%;
  //height:500px;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
}
</style>
